/*!
 * 存放与业务代码无关的公共常量，如：字典
 */
export * from "./dict";
export * from "./dictLabel";
export * from "./env";
export * from "./external";
export * from "./system";